import React from 'react';
import { withStyles } from "@material-ui/core";

const styles = theme => ({
    title: {
        border: "1px solid #E6EDF5",
        display: "inline-block",
        borderRadius: "30px",
        padding: "0 20px",
        color: "#767676",
        fontSize: "1em",
        lineHeight: "33px",
        marginBottom: "0px"
    },
    icon: {
        marginRight: '10px'
    }
})

const SidebarTitle = (props) => {
    let { classes } = props;

    return (<h3 className={classes.title}>
        {props.icon ? <span className={classes.icon}>{props.icon}</span> : ''}
        {props.title}
    </h3>)
};

export default withStyles(styles)(SidebarTitle);
